<template>
  <div>
    <!-- 状态:0 无权益,1:体验权益，2:全科权益	 -->
    <a-button
      class="ant-btn-secondary"
      @click="showModel(row, 0)"
      :disabled="jurisdiction === 2 || jurisdiction === 0"
    >
      无权益
    </a-button>
    <a-button
      class="ant-btn-secondary"
      @click="showModel(row, 1)"
      :disabled="jurisdiction === 2 || jurisdiction === 1"
      style="margin: 0 8px;"
    >
      体验权益
    </a-button>
    <a-button
      class="ant-btn-secondary"
      @click="showModel(row, 2)"
      :disabled="jurisdiction === 2"
    >
      小初全科权益
    </a-button>

    <a-modal
      :visible="modalVisible"
      :width="600"
      centered
      :mask-closable="false"
      ok-text="确定"
      :destroy-on-close="true"
      :confirm-loading="modalConfirmLoading"
      :closable="false"
      :z-index="103"
      @cancel="handleCancel"
      @ok="handleSubmit"
    >
      <template slot="title">
        <span v-if="this.giveRightType === NO_TO_ALL">请选择学生小初全科权益的有效期：</span>
        <span v-if="this.giveRightType === TRY_TO_ALL">请选择学生小初全科权益的有效期：</span>
      </template>

      <!-- 2.无权益变体全科权益 -->
      <div class="no-to-all" v-if="this.giveRightType === NO_TO_ALL">
        <a-radio-group name="radioGroup" v-model="noToAllRadio" :default-value="1">
          <a-radio
            :disabled="item.num === 0"
            :value="item.id"
            v-for="(item, index) in rightRadioOptions"
            :key="index"
          >
            {{ item.name }}(剩余{{ item.num }})
          </a-radio>
        </a-radio-group>
        <p class="tip" style="margin-top: 20px;">
          注意：确认后，将消减1个小初全科权益名额。
        </p>
      </div>

      <!-- 4.体验变全科 -->
      <div class="try-to-all" v-if="this.giveRightType === TRY_TO_ALL">
        <a-radio-group name="radioGroup" v-model="tryToAllRadio" :default-value="1">
          <a-radio
            :disabled="item.num === 0"
            :value="item.id"
            v-for="(item, index) in rightRadioOptions"
            :key="index"
          >
            {{ item.name }}(剩余{{ item.num }})
          </a-radio>
        </a-radio-group>
        <p class="tip" style="margin-top: 20px;">
          注意：确认后，体验权益名额不做返还，并消减1个小初全科权益名额。
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { NO_TO_TRY, NO_TO_ALL, TRY_TO_NO, TRY_TO_ALL } from './constant'
export default {
  name: 'RightAction',

  props: {
    stuInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      NO_TO_TRY,
      NO_TO_ALL,
      TRY_TO_NO,
      TRY_TO_ALL,
      giveRightType: null, // 权益转换的类型
      modalVisible: false,
      modalConfirmLoading: false,
      noToAllRadio: null,
      tryToAllRadio: null,
      rightRadioOptions: [
        {
          name: '永久有效',
          id: 1
        },
        {
          name: '三年有效',
          id: 2
        },
        {
          name: '一年有效',
          id: 3
        }
      ]
    }
  },

  computed: {
    jurisdiction () {
      return this.stuInfo.jurisdiction
    }
  },

  methods: {
    handleCancel() {
      this.modalVisible = false
    },

    // 保存权益
    handleSubmit() {
      const _this = this
      this.modalConfirmLoading = true
      // 0:无权益，10：体验权益,13:一年有效全科权益 14：三年有效全科权益  15:永久有效全科权益
      const jurisdictionMap = new Map()
      jurisdictionMap.set(NO_TO_TRY, 10) // 无->体验
      jurisdictionMap.set(NO_TO_ALL, this.noToAllRadio) // 无->全科
      jurisdictionMap.set(TRY_TO_NO, 0) // 体验->无
      jurisdictionMap.set(TRY_TO_ALL, this.tryToAllRadio) // 体验->全科
      if (this.giveRightType === NO_TO_ALL && !this.noToAllRadio) {
        this.$message.warning('请选择权益类型')
        this.modalConfirmLoading = false
        return
      }
      if (this.giveRightType === TRY_TO_ALL && !this.tryToAllRadio) {
        this.$message.warning('请选择权益类型')
        this.modalConfirmLoading = false
        return
      }

      const jurisdiction = jurisdictionMap.get(this.giveRightType)
      const { userId } = this.stuInfo

      return new Promise((resolve, reject) => {
        this.$service.studentRight.updRight({
          studentUserId: userId,
          jurisdiction
        }).then(res => {
          _this.modalVisible = false
          _this.modalConfirmLoading = false
          _this.$emit('updList')
          resolve()
        }).catch(err => {
          _this.modalConfirmLoading = false
          console.warn(`${_this.giveRightType}类型保存权益失败`, err)
          // eslint-disable-next-line prefer-promise-reject-errors
          reject()
        }).finally(() => {
          _this.modalConfirmLoading = false
        })
      })
    },

    // 获取全科权益单选
    getAllRightRadioOptions() {
      // https://yapi.aixuexi.com/project/42/interface/api/196985
      // 13:一年有效全科权益 14：三年有效全科权益  15:永久有效全科权益，传固定值
      this.$service.studentRight.insQuota({ cardType: [13, 14, 15] }).then(res => {
        this.rightRadioOptions = Object.keys(res).map(k => ({
          id: res[k].cardType,
          name: res[k].cardTypeDesc,
          num: res[k].residueNumber
        }))
      })
    },

    getHtml(currentRight) {
      let html
      if (currentRight === 0) { // 体验变无权益
        html = <div>
            <span >确认更改学生权益为：<span style="color:#3262FD">无权益</span> 吗？</span>
            <div class="try-to-no" style="margin-top: 16px;">
              <p class="tip">
                注意：已激活体验权益将会作废，不做返还。
              </p>
            </div>
          </div>
      } else { // 无权益变体验权益
        html = <div>
            <span>确认更改学生权益为：<span style="color:#3262FD">体验权益</span> 吗？</span>
              <div class="no-to-try" style="margin-top: 16px;">
                <p class="tip">
                  注意：确认后，将消减机构的1个体验权益名额。
                </p>
              </div>
          </div>
      }
      return html
    },

    showModel(row, currentRight) {
      this.noToAllRadio = null
      this.tryToAllRadio = null
      const { jurisdiction } = this.stuInfo

      if ([0, 1].includes(jurisdiction)) {
        if (jurisdiction === 0) this.giveRightType = currentRight === 1 ? NO_TO_TRY : NO_TO_ALL
        if (jurisdiction === 1) this.giveRightType = currentRight === 0 ? TRY_TO_NO : TRY_TO_ALL
      } else {
        throw new Error('列表权益类型异常')
      }

      if (currentRight === 2) {
        // 全科权益时三个按钮都禁用
        this.getAllRightRadioOptions() // 无权益或者体验权益转全科权益 - 获取单选项
        this.modalVisible = true
      } else {
        const content = this.getHtml(currentRight)
        this.$confirm({
          content: () => content,
          confirmLoading: this.modalConfirmLoading,
          centered: true,
          // 展示不下时，需要加滚动条
          onOk: () => this.handleSubmit(),
          cancelText: '取消'
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.xkh-teacher-model-overflow {
  .ant-modal-confirm-content {
    max-height: 100%;
    overflow-y: auto;
  }
}
</style>
